import React from 'react';

import { Text } from '../Text';

interface PlansIconProps {
  name: string;
  title: string;
  replaceWithText?: string | null;
  textClasses?: string;
}

export enum plansEnum {
  CORE = 'Core',
  MAX = 'Max',
  INFINITY = 'Infinity',
  INVEST = 'Greenlight + Invest'
}

export const getRewardByPlan = (name: string) => {
  switch (name) {
    case plansEnum.MAX:
      return 2;

    case plansEnum.INFINITY:
      return 5;

    case plansEnum.CORE:
    default:
      return 1;
  }
};

export default function PlansIcon({
  name,
  title,
  replaceWithText,
  textClasses = 'text-base font-medium text-[#1D252C] max-w-[200px]'
}: PlansIconProps) {
  if (replaceWithText) {
    return (
      <Text as="h3" className={textClasses} data-testid={`${name}-plan-text`}>
        {replaceWithText}
      </Text>
    );
  } else {
    return (
      <svg
        data-testid={`${name}-${title}`}
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="28"
        viewBox="0 0 22 24"
        fill="none"
      >
        <path
          d="M3.66675 12.0387L8.68987 17.5184L18.3334 7"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}
